export class SymbolHelpers {
    static invertAxis(axis) {
        return -axis;
    }
}
//# sourceMappingURL=SymbolHelpers.js.map